import axios from "axios";
import React, { useState } from "react";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../config";
export default function ForgotPasswordAdmin() {
  const [formData, setFormData] = useState({ email: "" });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const navigate = useNavigate();

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    const loadingToast = toast.loading("please wait ");
    try {
      const data = new FormData();
      data.append("email", formData.email);

      const response = await axios.post(
        `${API_BASE_URL}/api/admin/admin-forgotPassword`,
        data
      );
      // console.log("sdfghjk", response);
      if (response.data.statusCode === 200) {
        setTimeout(() => {
          navigate("/auth/verify-otp", { state: { email: formData.email } });
        }, 1500);

        toast.success("otp sent successfully to your mail id");
      } else {
        toast.error("Something went wrong");
      }
    } catch (error) {
      toast.error("Invalid Error! Please try again later");
    } finally {
      toast.dismiss(loadingToast);
    }
  };
  return (
    <div className="mb-16 mt-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start">
      <div className="mt-[10vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
        <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
          Forgot Password
        </h4>
        <p className="mb-9 ml-1 text-base text-gray-600">Enter your email !</p>
        <form onSubmit={handleForgotPassword}>
          <label className="dark:text-white">Email*</label>
          <input
            type="text"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Email"
            className="mt-2 flex h-12 w-full items-center justify-center rounded-xl border border-gray-200 bg-white/0 p-3 text-sm outline-none dark:!border-white/10 dark:text-white"
          />
          <button className="linear mt-7 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200">
            Submit
          </button>
        </form>
        <div className=" mb-4 mt-5 flex items-center justify-between px-2">
          <Link
            to="/auth/sign-in"
            className="mt-15 text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-white"
          >
            {" "}
            Back to Sign In!
          </Link>
        </div>
      </div>
    </div>
  );
}
